import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Lost in Migration — FTUE demo (3 essais).
 *
 * E1 : 100% congruent (5 oiseaux mêmes flèches), pédagogie "regarde le central".
 * E2 : incongruent introduit (flankers opposés au central).
 * E3 : vitesse normale, mix.
 */
import { useEffect, useRef, useState } from 'react';
const DEMO_STEPS = [
    {
        idx: 1,
        title: 'Essai 1 — base',
        hint: 'Pointe la direction de l’oiseau central. Tous les autres pointent dans la même direction.',
        central: 'right',
        flanker: 'right',
    },
    {
        idx: 2,
        title: 'Essai 2 — flankers opposés',
        hint: 'Cette fois les flankers volent dans une autre direction. Ignore-les. Concentre-toi sur le central.',
        central: 'left',
        flanker: 'right',
    },
    {
        idx: 3,
        title: 'Essai 3 — vitesse normale',
        hint: 'Tu es prêt. Vitesse normale.',
        central: 'right',
        flanker: 'left',
    },
];
const ARROW = {
    left: '←',
    right: '→',
    up: '↑',
    down: '↓',
};
export function Demo({ onComplete, onSkip }) {
    const [stepIdx, setStepIdx] = useState(0);
    const [phase, setPhase] = useState('fixation');
    const [picked, setPicked] = useState(null);
    const fixationTimer = useRef(null);
    const step = DEMO_STEPS[stepIdx];
    const isLast = stepIdx === DEMO_STEPS.length - 1;
    useEffect(() => {
        setPhase('fixation');
        setPicked(null);
        fixationTimer.current = setTimeout(() => setPhase('awaiting'), 600);
        return () => {
            if (fixationTimer.current)
                clearTimeout(fixationTimer.current);
        };
    }, [stepIdx]);
    const correct = (() => {
        if (phase !== 'feedback')
            return null;
        return picked === step.central;
    })();
    const handlePick = (d) => {
        if (phase !== 'awaiting')
            return;
        setPicked(d);
        setPhase('feedback');
    };
    const handleNext = () => {
        if (isLast) {
            onComplete();
            return;
        }
        setStepIdx((i) => i + 1);
    };
    const showBirds = phase === 'awaiting' || phase === 'feedback';
    const birds = [
        step.flanker,
        step.flanker,
        step.central,
        step.flanker,
        step.flanker,
    ];
    return (_jsxs("div", { className: "flex flex-1 flex-col items-center gap-s4 py-s4 text-center", children: [_jsx("p", { className: "font-mono text-[9.5px] uppercase tracking-[0.30em] text-cyan-text-faint", children: "D\u00E9mo guid\u00E9e" }), _jsx("h2", { className: "font-display text-[22px] font-medium leading-7 tracking-cy-display text-cyan-text", children: step.title }), _jsx("p", { className: "max-w-[320px] text-[13.5px] text-cyan-text-secondary", children: step.hint }), _jsxs("div", { className: "relative flex h-[200px] w-full max-w-[320px] items-center justify-center border border-cyan-border-faint bg-cyan-surface", children: [phase === 'fixation' && (_jsx("span", { className: "font-display text-[36px] text-cyan-text", children: "+" })), showBirds && (_jsx("div", { className: "flex flex-row items-center gap-[12px]", children: birds.map((d, i) => (_jsx("span", { className: [
                                'font-display text-[44px]',
                                i === 2 ? 'text-cyan-text' : 'text-cyan-text-secondary',
                            ].join(' '), children: ARROW[d] }, i))) })), phase === 'feedback' && (_jsx("span", { className: [
                            'absolute inset-0 flex items-center justify-center font-display text-[28px] font-medium',
                            correct ? 'text-cyan-core' : 'text-cyan-media',
                        ].join(' '), style: { background: 'rgba(255,255,255,0.85)' }, children: correct ? '✓' : '✗' }))] }), _jsxs("div", { className: "flex flex-col items-stretch gap-s3 self-stretch", children: [phase === 'awaiting' && (_jsxs("div", { className: "flex justify-center gap-s3", children: [_jsx("button", { type: "button", onClick: () => handlePick('left'), "aria-label": "Gauche", className: "flex h-[60px] w-[60px] items-center justify-center rounded-full border border-cyan-border bg-cyan-surface text-[28px] text-cyan-text hover:bg-cyan-bg active:scale-95", children: ARROW.left }), _jsx("button", { type: "button", onClick: () => handlePick('right'), "aria-label": "Droite", className: "flex h-[60px] w-[60px] items-center justify-center rounded-full border border-cyan-border bg-cyan-surface text-[28px] text-cyan-text hover:bg-cyan-bg active:scale-95", children: ARROW.right })] })), phase === 'feedback' && (_jsx("button", { type: "button", onClick: handleNext, className: "inline-flex h-12 w-full items-center justify-center bg-cyan-core font-display text-[14px] font-medium tracking-[-0.01em] text-cyan-surface transition active:scale-[0.985] hover:bg-cyan-network", children: isLast ? 'Démarrer la session' : 'Essai suivant' })), _jsx("button", { type: "button", onClick: onSkip, className: "text-[12px] text-cyan-text-secondary underline-offset-4 hover:underline", children: "Passer la d\u00E9mo" })] })] }));
}
//# sourceMappingURL=demo.js.map